//
//
//
//
//
//
//
//
export default {
  name: 'BottomInfo'
};